<template>
  <div class="opera-couponUse">
    <topNav :title="$t('couponUse_title')" url="/opera/"></topNav>
    <div class="warp" v-if="coupon">
      <div class="orderSta clearfix">
        <div class="Num">{{$t('couponUse_Num')}}:
          <span>{{ coupon.couponNo }}</span>
        </div>
        <div class="sta">{{$t('couponUse_sta')}}:
          <span>{{coupon.sta}}</span>
        </div>
      </div>
      <div class="infoList">
        <div class="info">
          <ul class="infoContent twocol">
            <li>{{$t('couponUse_couponName')}}:
              <span class="infoVal">{{coupon.couponName}}</span>
            </li>
            <li>{{$t('couponUse_couponCode')}}:
              <span class="infoVal">{{coupon.couponCode}}</span>
            </li>
            <li>{{$t('couponUse_couponTyDes')}}:
              <span class="infoVal">{{coupon.couponTyDes}}</span>
            </li>
            <li>{{$t('couponUse_cardNo')}}:
              <span class="infoVal">{{coupon.cardNo}}</span>
            </li>
            <li style="color:red">{{$t('couponUse_couponType')}}:
              <span class="infoVal" v-if="coupon.couponType=='RF'">{{coupon.presentValue}}{{$t('couponUse_P')}}</span>
              <span class="infoVal" v-else>￥{{coupon.presentValue}}</span>
            </li>
            <li>{{$t('couponUse_hotelDateSet')}}:
              <span class="infoVal">{{coupon.hotelDateSet}}</span>
            </li>
            <li>{{$t('couponUse_validFromDate')}}:
              <span class="infoVal">{{coupon.validFromDate}}</span>
            </li>
            <li>{{$t('couponUse_validToDate')}}:
              <span class="infoVal"> {{coupon.validToDate}}</span>
            </li>
            <li class="p100">{{$t('couponUse_couponDes')}}:
              <span class="infoVal">{{coupon.couponDes}}</span>
            </li>
            <li class="p100">{{$t('couponUse_remark')}}:
              <span class="infoVal">{{coupon.remark}}</span>
            </li>
          </ul>

        </div>

      </div>

    </div>
    <nothing :condition="empty"  :dis="edis"></nothing>
    <div class="staI">
      <div class="btn" @click='getbarcode' :class="{p100:!btnv}">{{$t('couponUse_getbarcode')}}</div>
      <div class="btn" @click='use' v-if="btnv">{{$t('couponUse_btnv')}}</div>

    </div>
  </div>
</template>
<script>
  import {Toast, MessageBox} from 'mint-ui';
  import nothing from '../operaCommon/nothing'

  export default {
    data() {
      return {
        coupon: null,
        btnv: false,
        empty: false,
        edis: "",

      }
    },
    mounted() {
      if (this.$route.query.couponNo) {
        this.getDetail(this.$route.query.couponNo)
      } else {
        this.empty = true;
        this.edis = this.$t('couponUse_tip');
      }
    },
    methods: {
      getDetail(v) {
        this.$http.post("/mobilepmsapi/member/getCouponDetailByNo?couponNo=" + v).then(res => {
          if (res.data.result == 0) {
            this.empty = false;
            this.coupon = res.data.retVal[0];
            if (this.coupon.sta == "I") {
              this.btnv = true;
            } else {
              this.msg(this.$t('msg_getDetail'));
            }
          } else {
            this.coupon = null;
            this.empty = true;
            this.edis = this.$t('couponUse_dis');
            this.btnv = false;
            this.msg(res.data.msg);
          }
        })
      },
      use() {
        MessageBox.confirm(this.$t('MessageBox_use')).then(action => {
          this.$http.post("/mobilepmsapi/member/couponUse?couponNo=" + this.$route.query.couponNo).then(res => {
            if (res.data.result == 0) {
              this.msg(this.$t('msg_use_success'));
              this.coupon.sta = "O";
              this.btnv = false;
            } else {
              this.msg(res.data.msg);
            }
          })
        });
      },
      getbarcode() {
        var A = plus.webview.getLaunchWebview();
        var that = this;
        window.barback = function (a) {
          that.$http.post('/mobilepmsapi/sys/getScanResult', {data: a}).then(res => {
            if (res.data.result == 0) {
              var d = res.data.retVal;
              if (d.type == "coupon") {
                that.getDetail(d.data);
              } else {
                that.msg(this.$t('msg_getbarcode'));
              }
            } else {
              that.msg(res.data.msg);
            }
          });
        };
        A.evalJS('getcardCode()');
      },
      msg(msg) {
        Toast({
          message: msg,
          position: 'bottom',
          duration: 3000
        });
      }
    },
    components: {
      nothing
    }
  }
</script>
<style lang='less'>
  .opera-couponUse {
    background: #f7f8fa;

    .warp {
      margin: 10px auto;
      background: #F6F8F9;

      .orderSta {
        background-color: #F6F8F9;
        height: 32px;
        line-height: 26px;
        color: #333;

        .Num {
          float: left;
          margin-left: 8px;
        }

        .sta {
          float: right;
          margin-right: 8px;

          span {
            color: #FFFFFF;
            font-weight: bold;
            font-size: 16px;
            border-radius: 12px;
            display: inline-block;
            width: 22px;
            height: 22px;
            text-align: center;
            background: #646F83;
            vertical-align: middle;
            line-height: 22px;
          }
        }
      }

      .infoList {
        margin: 0 10px;
        background: #fff;
        box-shadow: 0 -2px 20px rgba(0, 0, 0, 0.15);
        border-radius: 4px;

        .info {
          padding: 10px 0;

          .infoContent {
            margin: 0 20px;
            padding: 10px 0;
            clear: both;

            .p100 {
              clear: both;
              width: 100% !important;
            }

            li {
              margin: 2px auto;
              line-height: 20px;

              .infoVal {
                margin-left: 8px;

                a {
                  color: #000;
                }
              }

              .paiF {
                height: 32px;
                width: 70px;
                float: right;
                text-align: center;
                line-height: 32px;
                background-color: #f4f4f4;
                position: relative;
                top: -15px;
                border: 1px solid #ddd;
                border-radius: 4px;
              }
            }

            &.twocol {
              overflow: hidden;

              li {
                width: 50%;
                float: left;
              }
            }
          }
        }
      }
    }

    .staI {
      position: fixed;
      bottom: 0;
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 16px;
      line-height: 45px;
      height: 45px;
      background-image: linear-gradient(-90deg, #ff6e61 0%, #f6a129 98%);

      .btn {
        float: left;
        width: 50%;
        text-align: center;
        color: #fff;
        height: 15px;
        font-size: 15px;
        line-height: 15px;
        margin-top: 15px;
        box-sizing: border-box;
        border-right: 1px solid rgba(255, 255, 255, 0.5);
      }

      .p100 {
        width: 100%;
        border-right: 0
      }
    }
  }
</style>



// WEBPACK FOOTER //
// CouponUse.vue?452a9dd4